import moment from 'moment';
import uri from "../utils/uri";

export const billDefault = {
    id: 0,
    idMax: 0,
    date : new Date(moment().year(), moment().month(), moment().date(), 0, 0, 0, 0),
    clientId : null,      
    paymentTypeId : null, 
    paymentMethodId : null, 
    bankId : null, 
    creditDays : 0,      
    total : 0,
    observation: '',
    referencePayment: '',
    reference: '',
    billDetails : [],
    discountValue : "Ninguno",
    rate:0
} 

export const receiptDefault = {
    id: 0,
    date : new Date(moment().year(), moment().month(), moment().date(), 0, 0, 0, 0),
    billId: 0,
    amount : '',   
    balance : 0,   
    observation: '',    
    client: '',    
    reference: '',    
    paid :false,
    paymentMethodId : null, 
    bankId : null, 
    referencePayment: '',
    maxId: 0,
} 

export const paymentType = {
    contado : 1,
    credito : 2
}

export const typesBill = {
    cotizacion : 1,
    factura : 2
}


const config = {
    1: {
        text : 'Proforma',
        title : 'Proformas',
        uri : uri.quotation,
        typeId : 1
    },
    2: {
        text : 'factura',
        title : 'Facturas',
        uri : uri.bill,
        typeId : 2
    }
}

export const getConfig = typeId => config[typeId];
